<div class="footer-title">
    <h4>why we choose</h4>
</div>
<div class="footer-contant">
    <ul>
        <li><a [routerLink]="[]">shipping & return</a></li>
        <li><a [routerLink]="[]">secure shopping</a></li>
        <li><a [routerLink]="[]">gallary</a></li>
        <li><a [routerLink]="[]">affiliates</a></li>
        <li><a [routerLink]="[]">contacts</a></li>
    </ul>
</div>